<div
    class="d-flex fixed-bottom p-2 justify-content-md-between z-99 mt-5 border-top bg-body-secondary small font-monospace shadow-top">
    <div class="text-center">
        <i class="bi {{ configuration.appType === 'frontEnd' ? 'bi-front' : 'bi-back' }}"></i>
        <span class="mx-1">|</span>
        <span class="fw-semibold text-success">{{ configuration.appDeveloper }}</span>
        <span class="mx-1">|</span>
        <span>&copy; {{ configuration.appYear }} - All rights reserved</span>
        <span class="mx-1">|</span>
        <span class="fst-italic">version {{ configuration.appVersion }}</span>
    </div>
    <div class="d-none d-lg-block">
        <span class="mx-1 py-1 fst-italic">
            {{ statusBarText }}
        </span>
    </div>
</div>